import React from 'react';
import { DOT_SEPARATOR } from 'consts/symbols';
import { useLocale } from 'locale';
import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';
import { isNil } from 'lodash';
import { TextAlignProperty, WhiteSpaceProperty } from 'csstype';

interface PropertiesSummaryTextProps {
  textAlign: TextAlignProperty;
  whiteSpace: WhiteSpaceProperty;
}

export const PropertiesSummaryText = styled(SmallText)<PropertiesSummaryTextProps>`
  ${({ theme, textAlign, whiteSpace }) => `
    color: ${theme.colors.neutrals.grey3};
    white-space: ${whiteSpace};
    text-align: ${textAlign};
  `}
`;

type PropertiesSummaryProps = Partial<PropertiesSummaryTextProps> & {
  soldCount: number;
  exclusiveListingsCount: number;
};

export const PropertiesSummary: React.FC<PropertiesSummaryProps> = props => {
  const {
    soldCount = null,
    exclusiveListingsCount = null,
    textAlign = 'center',
    whiteSpace = 'nowrap',
  } = props;
  const { t } = useLocale();
  const text = [
    isNil(soldCount) ? null : t('madad.soldCount', { count: soldCount }),
    isNil(exclusiveListingsCount) ? null : t('madad.exclusiveListingsCount', { count: exclusiveListingsCount }),
  ].filter(Boolean).join(DOT_SEPARATOR);
  return text ? (
    <PropertiesSummaryText
      textAlign={textAlign}
      whiteSpace={whiteSpace}
    >
      {text}
    </PropertiesSummaryText>
  ) : null;
};
